import { Box, Chip, Divider, Paper, Stack, Typography } from '@mui/material';
import { LocalFlorist, Memory, Verified, SettingsApplications } from '@mui/icons-material';
import React, { Component } from 'react';
import Global from "../../customlib/Global";
import doodleBg from "../MessageList/doodle-prestisa.svg";


class WelcomeMessage extends Component {
    state = {}
    render() {
        return (
            <Box>
                {this.props.children}

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "75vh",
                        px: 2,
                    }}
                >
                    <Paper
                        elevation={0}
                        sx={{
                            width: "100%",
                            maxWidth: 600,
                            textAlign: "center",
                            borderRadius: "24px",
                            overflow: "hidden",
                            border: "1px solid #d4d5fa",
                            boxShadow: "0 12px 40px rgba(16, 24, 40, 0.10)",
                            backgroundColor: "#ffffff",
                            backgroundImage: `url(${doodleBg})`,
                            backgroundRepeat: "repeat",
                            backgroundSize: "240px 240px",
                        }}
                    >
                        {/* Header dengan gradient & ikon bunga */}
                        <Box
                            sx={{
                                // background: "linear-gradient(135deg, #941d59 0%, #e3577f 100%)",
                                py: 4,
                                display: "flex",
                                justifyContent: "center",
                                // backgroundColor: "#f79de320"
                            }}
                        >
                            <Box
                                sx={{
                                    width: 76,
                                    height: 76,
                                    borderRadius: "50%",
                                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    boxShadow: "0 6px 18px rgba(0,0,0,0.18)",
                                }}
                            >
                                <LocalFlorist sx={{ fontSize: 40, color: "#941d59" }} />
                            </Box>
                        </Box>

                        {/* <Box sx={{height: "1px", backgroundColor: '#fbc68d', ml: "20%", mr: "20%"}}></Box> */}

                        {/* Konten */}
                        <Box sx={{ p: 4 }}>
                            <Typography variant="h4" sx={{ fontWeight: 800, color: "#1f2a44", letterSpacing: 0.2 }}>
                                Selamat Datang
                            </Typography>
                            <Typography sx={{ color: "#667085", mt: 1.25, fontSize: 15 }}>
                                "<Box component="span" sx={{ fontWeight: 700, color: "#941d59" }}>Semangat</Box> menjalankan aktivitas hari ini"
                            </Typography>

                            <Stack
                                direction="row"
                                spacing={1}
                                useFlexGap
                                flexWrap="wrap"
                                justifyContent="center"
                                alignContent={"center"}
                                alignItems={"center"}
                                alignSelf={"center"}
                                sx={{ mt: 3.5 }}
                            >
                                <Chip
                                    size="small"
                                    // color="primary"
                                    variant='outlined'
                                    icon={<SettingsApplications />}
                                    label={"Version " + Global.appVersion()}
                                    // sx={{ fontWeight: 600 }}
                                />
                                <Chip
                                    size="small"
                                    variant="outlined"
                                    icon={<Memory />}
                                    label={"Build " + Global.buildInfo()}
                                />

                                {
                                    process.env.REACT_APP_MODE !== "PRODUCTION" && (
                                        <Chip
                                            size="small"
                                            variant="outlined"
                                            color="success"
                                            icon={<Verified />}
                                            label={process.env.REACT_APP_MODE}
                                        />
                                    )
                                }
                                
                            </Stack>
                        </Box>
                    </Paper>
                </Box>
            </Box>
        );
    }
}

export default WelcomeMessage;
